export const BOOT_ID_HEADER = 'x-dash-boot-id';
export const BOOT_ID_STORAGE_KEY = 'dash_api_boot_id';

let logoutInProgress = false;

export function resetServiceEpochGuardState() {
    logoutInProgress = false;
}

export function readStoredServiceBootId() {
    if (typeof window === 'undefined') {
        return null;
    }
    try {
        return sessionStorage.getItem(BOOT_ID_STORAGE_KEY);
    } catch {
        return null;
    }
}

export function writeStoredServiceBootId(bootId) {
    if (typeof window === 'undefined' || !bootId) {
        return;
    }
    try {
        sessionStorage.setItem(BOOT_ID_STORAGE_KEY, bootId);
    } catch {
        // ignore
    }
}

export function clearStoredServiceBootId() {
    if (typeof window === 'undefined') {
        return;
    }
    try {
        sessionStorage.removeItem(BOOT_ID_STORAGE_KEY);
    } catch {
        // ignore
    }
}

/**
 * Compare dash-api bootId from a response/header/body. Signs the user out when
 * dash-api restarted while this tab still holds stale client state.
 */
export async function observeServiceBootId(bootId, meta = {}) {
    if (!bootId || typeof window === 'undefined' || logoutInProgress) {
        return;
    }

    const stored = readStoredServiceBootId();
    if (!stored) {
        writeStoredServiceBootId(bootId);
        return;
    }
    if (stored === bootId) {
        return;
    }

    const {getUser} = await import('../auth/jwtAuth');
    if (!getUser()) {
        writeStoredServiceBootId(bootId);
        return;
    }

    logoutInProgress = true;
    clearStoredServiceBootId();

    const {forceLogoutForCollaborationReset} = await import(
        '../components/prosemirror-editor/core/forceLogoutForCollaborationReset'
    );
    forceLogoutForCollaborationReset({
        reason: 'service-restart',
        bootId,
        previousBootId: stored,
        ...meta,
    });
}

export function observeServiceBootIdFromResponse(response, meta = {}) {
    if (!response?.headers) {
        return Promise.resolve();
    }
    const bootId = response.headers.get(BOOT_ID_HEADER)
        || response.headers.get('X-Dash-Boot-Id');
    if (!bootId) {
        return Promise.resolve();
    }
    return observeServiceBootId(bootId, meta);
}
